module.exports = __webpack_public_path__ + "static/media/illustration-modal-chamado.62b3dc72.svg";